export default {
  init() {
    // JavaScript to be fired on all pages

    var $hamburger = $('.hamburger');
    $hamburger.on('click', function() {
      $hamburger.toggleClass('is-active');
      // Do something else, like open/close menu
      $('body').toggleClass('menu-open');
    });

    function detect_scrolled(){

      if($(window).scrollTop() > 100){
        $( 'body, header.banner' ).addClass( 'scrolled' );
      } else{
        $( 'body, header.banner' ).removeClass( 'scrolled' );
      }

    }

    var scrollInterval = null;

    $(window).scroll(function(){ detect_scrolled(); });

    $(window).on('touchmove', function() {
      scrollInterval = window.setInterval('detect_scrolled', 100);
    });
    $(window).on('touchend', function() {
      clearInterval(scrollInterval);
    });

    detect_scrolled();

    $('form.mepr-form :input').each(function(index, elem) {

      var eId = $(elem).attr('id');

      var label = null;

      if (eId && (label = $(elem).parents('form').find('label[for='+eId+']')).length === 1) {

          var placeholder = $(label).html();
          $(elem).attr('placeholder', placeholder.replace(':',' '));

          if (!$(label).hasClass('mepr-checkbox-field')) {
            $(label).addClass('sr-only');
          }

      }

   });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js